import { ACHPaymentInfoDTO } from 'shared/modules/carrier-profile/data/CarrierProfileDTO';

export function isACHDataEmpty(data?: ACHPaymentInfoDTO) {
  return !(
    data &&
    (data.bank_account_number ||
      data.bank_name ||
      data.bank_routing_number ||
      data.voided_check_url)
  );
}
